module.exports = __webpack_public_path__ + "static/media/asia-gaming.4511b704.svg";